var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 305.782,
    height: 237.909,
    viewBox: "0 0 305.782 237.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fd7f80;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fab2b3;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-25, .cls-26, .cls-27, .cls-42, .cls-5, .cls-7, .cls-9 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: #20b989;\r\n      }\r\n\r\n      .cls-25, .cls-5, .cls-7, .cls-9 {\r\n        stroke-width: 0.5px;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke: #27c492;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-9 {\r\n        stroke: #1faf81;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #694d42;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #9d6686;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #3e3b68;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #e7e6f8;\r\n      }\r\n\r\n      .cls-15, .cls-20, .cls-39, .cls-40, .cls-41 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #e9e8f7;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #c18ae9;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #df9cd0;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-20 {\r\n        font-size: 7px;\r\n        font-family: Karla-Bold, Karla;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #8493f4;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-25 {\r\n        stroke: #e9e8f7;\r\n        stroke-linecap: square;\r\n      }\r\n\r\n      .cls-26 {\r\n        stroke: #c18ae9;\r\n      }\r\n\r\n      .cls-27 {\r\n        stroke: #6577e9;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #6264db;\r\n        opacity: 0.232;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #717fe0;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #f6c8c5;\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-34 {\r\n        opacity: 0.472;\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-38 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-39 {\r\n        opacity: 0.601;\r\n      }\r\n\r\n      .cls-40 {\r\n        opacity: 0.596;\r\n      }\r\n\r\n      .cls-41 {\r\n        opacity: 0.396;\r\n      }\r\n\r\n      .cls-42 {\r\n        stroke: #707070;\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: #7f59cc;\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: #f08762;\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-49 {\r\n        filter: url(#Oval-2);\r\n      }\r\n\r\n      .cls-50 {\r\n        filter: url(#Oval);\r\n      }\r\n\r\n      .cls-51 {\r\n        filter: url(#bg-2);\r\n      }\r\n\r\n      .cls-52 {\r\n        filter: url(#right-hand);\r\n      }\r\n\r\n      .cls-53 {\r\n        filter: url(#Feet);\r\n      }\r\n\r\n      .cls-54 {\r\n        filter: url(#Value_Copy_10);\r\n      }\r\n\r\n      .cls-55 {\r\n        filter: url(#Path_6);\r\n      }\r\n\r\n      .cls-56 {\r\n        filter: url(#Path_6_Copy);\r\n      }\r\n\r\n      .cls-57 {\r\n        filter: url(#Rectangle_Copy_13);\r\n      }\r\n\r\n      .cls-58 {\r\n        filter: url(#Rectangle_Copy_10);\r\n      }\r\n\r\n      .cls-59 {\r\n        filter: url(#Rectangle_Copy);\r\n      }\r\n\r\n      .cls-60 {\r\n        filter: url(#Rectangle_Copy_4);\r\n      }\r\n\r\n      .cls-61 {\r\n        filter: url(#Rectangle_Copy_2);\r\n      }\r\n\r\n      .cls-62 {\r\n        filter: url(#Rectangle_Copy_8);\r\n      }\r\n\r\n      .cls-63 {\r\n        filter: url(#Rectangle_Copy_7);\r\n      }\r\n\r\n      .cls-64 {\r\n        filter: url(#Rectangle_Copy_11);\r\n      }\r\n\r\n      .cls-65 {\r\n        filter: url(#_1);\r\n      }\r\n\r\n      .cls-66 {\r\n        filter: url(#Path);\r\n      }\r\n\r\n      .cls-67 {\r\n        filter: url(#_2);\r\n      }\r\n\r\n      .cls-68 {\r\n        filter: url(#_3);\r\n      }\r\n\r\n      .cls-69 {\r\n        filter: url(#bg);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.052,
    x2: 0.248,
    y2: 1.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82c3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626be6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg",
    x: 20.661,
    y: 90.5,
    width: 68.566,
    height: 57.452,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8493f4",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.559,
    y1: -0.113,
    x2: 0.493,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84f6bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22b989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.336,
    x2: 0.928,
    y2: 0.898,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76edaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b889"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.845,
    y1: -0.118,
    x2: 0.243,
    y2: 0.836,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ef192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2dc897"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1,
    y1: 0.116,
    x2: 0.168,
    y2: 0.925,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd7b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3168"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_3",
    x: 84.191,
    y: 171.748,
    width: 109.05,
    height: 43.436,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1,
    y1: 0.116,
    x2: 0.169,
    y2: 0.925,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbbcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a665d1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_2",
    x: 84.191,
    y: 147.453,
    width: 109.05,
    height: 43.436,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1,
    y1: 0.145,
    x2: 0.133,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cb5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a71ef"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path",
    x: 87.552,
    y: 145.692,
    width: 47.458,
    height: 47.457,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1",
    x: 84.191,
    y: 123.968,
    width: 109.05,
    height: 42.626,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_11",
    x: 93.011,
    y: 123.827,
    width: 44.43,
    height: 50.908,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.05,
    y1: 0.074,
    x2: 0.174,
    y2: 0.874,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f85e7a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_7",
    x: 93.011,
    y: 130.305,
    width: 44.43,
    height: 44.429,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_8",
    x: 89.771,
    y: 127.066,
    width: 44.43,
    height: 47.669,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_2",
    x: 86.531,
    y: 128.686,
    width: 44.43,
    height: 46.049,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_4",
    x: 83.291,
    y: 123.827,
    width: 44.43,
    height: 50.908,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy",
    x: 83.291,
    y: 125.446,
    width: 44.43,
    height: 49.288,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1.059,
    y1: -0.068,
    x2: 0.185,
    y2: 0.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_10",
    x: 80.051,
    y: 129.496,
    width: 44.43,
    height: 45.239,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_13",
    x: 84.191,
    y: 40.556,
    width: 109.05,
    height: 100.934,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d1d4e2",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6_Copy",
    x: 89.932,
    y: 84.976,
    width: 97.343,
    height: 28.56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8ea5b4",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6",
    x: 90.025,
    y: 69.484,
    width: 96.855,
    height: 33.701,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8ea5b4",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Value_Copy_10",
    x: 146.561,
    y: 57.991,
    width: 48.226,
    height: 35.732,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c4d4df",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.661,
    y1: 0.045,
    x2: 0.403,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d3a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feet",
    x: 186.319,
    y: 145.697,
    width: 42.2,
    height: 77.704,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: -0.105,
    x2: 0.5,
    y2: 1.133,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2e27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.917,
    y1: -0.083,
    x2: 0.556,
    y2: 1.033,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c38ffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f7af7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "right-hand",
    x: 209.069,
    y: 108.782,
    width: 45.437,
    height: 74.816,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8493f4",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: 0.473,
    x2: 1.149,
    y2: 0.545,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6ee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba79d7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.916,
    y1: -0.083,
    x2: 0.555,
    y2: 1.033,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.57,
    y1: 0.255,
    x2: 0.5,
    y2: 1.064,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c6de4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8780f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.8,
    y1: 0.033,
    x2: 0.331,
    y2: 1.037,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c8c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f39d97"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-2",
    x: 20.661,
    y: 90.5,
    width: 68.566,
    height: 57.452,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8493f4",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-3",
    "data-name": "bg",
    className: "cls-1",
    width: 32.566,
    height: 21.452,
    rx: 3
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.5,
    y1: -0.237,
    x2: 0.138,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbadb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.297,
    y1: -0.175,
    x2: 0.725,
    y2: 1.13,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Oval",
    x: 250.858,
    y: 48.102,
    width: 54.924,
    height: 54.765,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a19fc4",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.145,
    y1: 0.022,
    x2: 0.851,
    y2: 0.855,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9b0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a63e5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Oval-2",
    x: 0.17,
    y: 140.08,
    width: 57.582,
    height: 56.59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a19fc4",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1,
    y1: -0.072,
    x2: 0.432,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd79a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88862"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-1.339 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(26 37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rug",
    transform: "translate(74.483 166.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rug-2",
    "data-name": "rug",
    className: "cls-2",
    d: "M0,32.847,34.037,1.825,193.53,0l-21.6,32.847Z",
    transform: "translate(0 0.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rug_copy",
    "data-name": "rug copy",
    className: "cls-3",
    d: "M0,32.607,33.054,1.4,153.655,0l-22.8,32.607Z",
    transform: "translate(19.989 1.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-2",
    d: "M4.2,1.547S-5.7,12.2,7.752,14.682,0,32.391,17.648,32.627s68.686,0,68.686,0L109.291,0Z",
    transform: "translate(54.028 0.81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FlowerPot",
    transform: "translate(6.747 106.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leave",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 10.185, 0.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Middle",
    transform: "translate(25.788 0.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Middle-2",
    "data-name": "Middle",
    className: "cls-4",
    d: "M3.382,51.005S-1.1,34.927,4.73,28.918c5.384-6.354,7.892-5.031,7.159-13.591A21.338,21.338,0,0,1,14.423,0S3.869,7.054,1.774,16.7c-3.547,11.295,0,34.3,0,34.3",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-5",
    d: "M10.6,0S5.776,6.111,5.776,9.473s1.636,7.987-1.89,11.446S-1.006,34.006.79,44.6",
    transform: "translate(1.006 3.255)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left",
    transform: "translate(0.234 18.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left-2",
    "data-name": "Left",
    className: "cls-6",
    d: "M0,0S9.855,6.391,10.889,12.018c.995,5.568,1.929,6.975,9.869,11.036,8.236,3.784,11.484,5.778,10.17,13.427a18.054,18.054,0,0,1-.529,1.937h1.9s3.147-10.958-8.185-25.034C12.679.645,0,0,0,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-7",
    d: "M0,0S7.476,2.558,8.464,5.968s2.365,7.044,5.3,7.044c4.373,0,8.367,4,11.926,12.807,1.444,3.572.49,10.275.49,10.275",
    transform: "translate(5.246 2.719)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(28.542 11.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Right-2",
    "data-name": "Right",
    className: "cls-8",
    d: "M2.145,38.853s-.5-7.973,3.219-13.116S14.87,21.147,23,15.771C28.932,12.1,31.4,0,31.4,0S24.176.972,17.482,8.232c-6.808,7.383-9.694,12.652-11.55,14.92C2.377,27.99,0,38.853,0,38.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-9",
    d: "M29.08,0s-4.836,2.622-4.836,4.84-1.562,5.384-4.141,5.384S15.817,12.695,14.54,14.7c-1.7,2.665-6.021,4.224-10.653,10.128C1.205,28.243,0,37.733,0,37.733",
    transform: "translate(0.868 1.088)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ground",
    className: "cls-10",
    d: "M0,5.809S2.636,0,5.867,0s6.588,2.9,7.277,2.9,2.32-1.6,4.826-1.607,7.745,4.5,7.745,4.5Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 17.521, 48.302)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    className: "cls-11",
    d: "M2.389.119S-.245,2.876.025,8.979A15.019,15.019,0,0,0,7.781,21.512c4.205,2.36,19.156,4.853,29.681,0,4.017-1.852,8.5-5.738,8.5-12.533C45.963,2.718,42.908,0,42.908,0Z",
    transform: "translate(8.064 57.493)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "cls-12",
    width: 43.544,
    height: 1.62,
    rx: 0.81,
    transform: "translate(9.676 56.684)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(87 23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-13",
    d: "M15.8,0h73.71a15.811,15.811,0,0,1,15.8,15.826V168.814a15.811,15.811,0,0,1-15.8,15.826H15.8A15.811,15.811,0,0,1,0,168.814V15.826A15.811,15.811,0,0,1,15.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-14",
    d: "M10.53,0A10.54,10.54,0,0,0,0,10.551V163.539A10.54,10.54,0,0,0,10.53,174.09H84.24a10.54,10.54,0,0,0,10.53-10.551V10.551A10.54,10.54,0,0,0,84.24,0Z",
    transform: "translate(5.67 5.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    className: "cls-13",
    d: "M2.915,0H45.685A2.915,2.915,0,0,1,48.6,2.915v0a6.8,6.8,0,0,1-6.8,6.8H6.8A6.8,6.8,0,0,1,0,2.915v0A2.915,2.915,0,0,1,2.915,0Z",
    transform: "translate(28.431 2.883)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3-2",
    "data-name": 3,
    transform: "translate(10.53 152.248)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68",
    transform: "matrix(1, 0, 0, 1, -96.19, -175.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_3-3",
    "data-name": 3,
    className: "cls-15",
    width: 85.05,
    height: 19.436,
    rx: 3,
    transform: "translate(96.19 175.75)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "date",
    className: "cls-16",
    width: 32.4,
    height: 2.429,
    rx: 1,
    transform: "translate(27.54 11.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Transaction",
    className: "cls-17",
    width: 14.58,
    height: 2.429,
    rx: 1.215,
    transform: "translate(27.54 5.669)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(7.29 3.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-18",
    d: "M3.893,3.509,5.265.136A.635.635,0,0,0,4.877,0a1.934,1.934,0,0,0-.852.327l-.1.055a2.165,2.165,0,0,1-1,.334A1.115,1.115,0,0,1,2.437.6,3.76,3.76,0,0,0,.9.1,1.22,1.22,0,0,0,0,.523L1.494,3.509Z",
    transform: "translate(2.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-19",
    d: "M8.638,8.773a1.913,1.913,0,0,0,1.34-.542,1.813,1.813,0,0,0,.553-1.283q0-.014,0-.028A7.81,7.81,0,0,0,8.495,1.785,10.533,10.533,0,0,0,6.549,0H3.982A10.691,10.691,0,0,0,2.036,1.785,7.83,7.83,0,0,0,0,6.92,1.826,1.826,0,0,0,.558,8.231a1.916,1.916,0,0,0,1.34.542Z",
    transform: "translate(0 4.049)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    className: "cls-20",
    transform: "translate(3.24 4.908)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6
  }, "$")))), /*#__PURE__*/React.createElement("g", {
    id: "_2-2",
    "data-name": 2,
    transform: "translate(10.53 127.953)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67",
    transform: "matrix(1, 0, 0, 1, -96.19, -151.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_2-3",
    "data-name": 2,
    className: "cls-15",
    width: 85.05,
    height: 19.436,
    rx: 3,
    transform: "translate(96.19 151.45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "date-2",
    "data-name": "date",
    className: "cls-16",
    width: 30.78,
    height: 2.429,
    rx: 1,
    transform: "translate(27.54 11.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Transaction-2",
    "data-name": "Transaction",
    className: "cls-21",
    width: 12.15,
    height: 2.429,
    rx: 1.215,
    transform: "translate(27.54 5.669)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.48 3.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    className: "cls-16",
    d: "M9.72,4.859A4.858,4.858,0,1,1,4.86,0a.371.371,0,0,1,.372.372V4.487H9.348a.374.374,0,0,1,.372.372Z",
    transform: "translate(0 1.62)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-66",
    transform: "matrix(1, 0, 0, 1, -102.67, -154.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    className: "cls-22",
    d: "M4.19,1.714A5.076,5.076,0,0,1,5.458,5.053v.017a.387.387,0,0,1-.388.388H.388A.387.387,0,0,1,0,5.069V.388A.387.387,0,0,1,.388,0,5.074,5.074,0,0,1,4.19,1.714Z",
    transform: "translate(108.55 154.69)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(10.53 104.468)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65",
    transform: "matrix(1, 0, 0, 1, -96.19, -127.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_1-3",
    "data-name": 1,
    className: "cls-15",
    width: 85.05,
    height: 18.626,
    rx: 3,
    transform: "translate(96.19 127.97)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "date-3",
    "data-name": "date",
    className: "cls-16",
    width: 38.88,
    height: 2.429,
    rx: 1,
    transform: "translate(27.54 11.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Transaction-3",
    "data-name": "Transaction",
    className: "cls-2",
    width: 19.44,
    height: 2.429,
    rx: 1.215,
    transform: "translate(27.54 5.669)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Graph",
    transform: "translate(4.86 4.859)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_11-2",
    "data-name": "Rectangle Copy 11",
    className: "cls-16",
    width: 2.43,
    height: 8.908,
    rx: 0.5,
    transform: "translate(114.01 132.83)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_7-2",
    "data-name": "Rectangle Copy 7",
    className: "cls-23",
    width: 2.43,
    height: 2.429,
    rx: 0.5,
    transform: "translate(114.01 139.31)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_3",
    "data-name": "Rectangle Copy 3",
    className: "cls-16",
    width: 2.43,
    height: 8.908,
    rx: 0.5,
    transform: "translate(9.72)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-62",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_8-2",
    "data-name": "Rectangle Copy 8",
    className: "cls-23",
    width: 2.43,
    height: 5.669,
    rx: 0.5,
    transform: "translate(110.77 136.07)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_6",
    "data-name": "Rectangle Copy 6",
    className: "cls-16",
    width: 2.43,
    height: 8.908,
    rx: 0.5,
    transform: "translate(6.48)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_2-2",
    "data-name": "Rectangle Copy 2",
    className: "cls-23",
    width: 2.43,
    height: 4.049,
    rx: 0.5,
    transform: "translate(107.53 137.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_4-2",
    "data-name": "Rectangle Copy 4",
    className: "cls-16",
    width: 2.43,
    height: 8.908,
    rx: 0.5,
    transform: "translate(104.29 132.83)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy-2",
    "data-name": "Rectangle Copy",
    className: "cls-23",
    width: 2.43,
    height: 7.288,
    rx: 0.5,
    transform: "translate(104.29 134.45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    className: "cls-16",
    width: 2.43,
    height: 8.908,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58",
    transform: "matrix(1, 0, 0, 1, -101.05, -132.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_10-2",
    "data-name": "Rectangle Copy 10",
    className: "cls-24",
    width: 2.43,
    height: 3.239,
    rx: 0.5,
    transform: "translate(101.05 138.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Graph-2",
    "data-name": "Graph",
    transform: "translate(10.53 21.056)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57",
    transform: "matrix(1, 0, 0, 1, -96.19, -44.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_13-2",
    "data-name": "Rectangle Copy 13",
    className: "cls-15",
    width: 85.05,
    height: 76.934,
    rx: 5,
    transform: "translate(96.19 44.56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "translate(10.53 18.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy_5",
    "data-name": "Line 5 Copy 5",
    className: "cls-25",
    d: "M.405,0V49.4",
    transform: "translate(64.8 0.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy_4",
    "data-name": "Line 5 Copy 4",
    className: "cls-25",
    d: "M.486,0,.324,49.4",
    transform: "translate(51.84 0.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy_6",
    "data-name": "Line 5 Copy 6",
    className: "cls-25",
    d: "M.486,0,.324,49.4",
    transform: "translate(38.88 0.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy_3",
    "data-name": "Line 5 Copy 3",
    className: "cls-25",
    d: "M.486,0,.324,49.4",
    transform: "translate(25.92 0.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy_2",
    "data-name": "Line 5 Copy 2",
    className: "cls-25",
    d: "M.405,0V49.4",
    transform: "translate(12.96 0.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "cls-25",
    d: "M.405,0V49.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Days",
    transform: "translate(2.43 64.786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_9",
    "data-name": "Value Copy 9",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62,
    transform: "translate(75.842)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_8",
    "data-name": "Value Copy 8",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62,
    transform: "translate(64.147)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_7",
    "data-name": "Value Copy 7",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62,
    transform: "translate(50.831)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_6",
    "data-name": "Value Copy 6",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62,
    transform: "translate(38.326)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_5",
    "data-name": "Value Copy 5",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62,
    transform: "translate(25.011)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_4",
    "data-name": "Value Copy 4",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62,
    transform: "translate(11.695)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_Copy_3",
    "data-name": "Value Copy 3",
    className: "cls-16",
    width: 5.707,
    height: 3.239,
    rx: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56",
    transform: "matrix(1, 0, 0, 1, -96.19, -44.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6_Copy-2",
    "data-name": "Path 6 Copy",
    className: "cls-26",
    d: "M0,13.407a18.7,18.7,0,0,0,11.087,1.98C17.6,14.6,18.817,6.16,23.776,6.16S29.5,10.636,35.64,9.173C40.424,8.033,43.654,0,49.41,0s7.321,9.173,14.58,9.173c5.485,0,5.833-6.743,11.34-6.743,4.808,0,4.745,7.08,9.72,6.743",
    transform: "translate(96.19 87.48)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55",
    transform: "matrix(1, 0, 0, 1, -96.19, -44.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    className: "cls-27",
    d: "M0,19.831S6.19,22,9.72,18.731c3.488-3.233,4.86-9.4,10.9-9.4s3.7,5.986,13.4,5.28C41.783,14.044,41.31,0,47.79,0s7.963,14.61,15.067,14.61c7.185,0,6.227-6.688,11.734-6.688,4.808,0,4.372,7.334,10.042,6.688",
    transform: "translate(96.19 71.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tooltip",
    transform: "translate(62.37 19.436)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54",
    transform: "matrix(1, 0, 0, 1, -158.56, -63.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Value_Copy_10-2",
    "data-name": "Value Copy 10",
    className: "cls-21",
    d: "M0,1A1,1,0,0,1,1,0H23.226a1,1,0,0,1,1,1V9.118a1,1,0,0,1-1,1H14.6a1,1,0,0,0-.713.3l-1,1.017a1,1,0,0,1-1.371.052l-1.281-1.12a1,1,0,0,0-.658-.247H1a1,1,0,0,1-1-1Z",
    transform: "translate(158.56 63.99)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    className: "cls-15",
    width: 18.029,
    height: 3.555,
    rx: 1,
    transform: "translate(3.099 3.259)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pointer",
    transform: "translate(72.09 32.393)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    className: "cls-28",
    cx: 3.645,
    cy: 3.644,
    rx: 3.645,
    ry: 3.644,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    "data-name": "Oval",
    className: "cls-15",
    cx: 2.835,
    cy: 2.834,
    rx: 2.835,
    ry: 2.834,
    transform: "translate(0.81 0.81)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    className: "cls-21",
    cx: 1.215,
    cy: 1.215,
    rx: 1.215,
    ry: 1.215,
    transform: "translate(2.43 2.429)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tabs",
    transform: "translate(4.86 6.479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Link_3_Copy",
    "data-name": "Link 3 Copy",
    className: "cls-16",
    width: 14.58,
    height: 2.972,
    rx: 1.486,
    transform: "translate(61.097)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Link_3",
    "data-name": "Link 3",
    className: "cls-16",
    width: 13.872,
    height: 2.972,
    rx: 1.486,
    transform: "translate(40.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "selected",
    className: "cls-21",
    width: 4.954,
    height: 0.743,
    rx: 0.371,
    transform: "translate(25.92 4.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Link_2",
    "data-name": "Link 2",
    className: "cls-21",
    width: 11.89,
    height: 2.972,
    rx: 1.486,
    transform: "translate(22.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Link_1",
    "data-name": "Link 1",
    className: "cls-16",
    width: 16.2,
    height: 2.972,
    rx: 1.486,
    transform: "translate(0.55)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ManPoiting",
    transform: "translate(169 59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Foot_1",
    "data-name": "Foot 1",
    className: "cls-29",
    d: "M5.816,0S-.405.076.028,3.6,7,9,11.64,9.242s5.58-.583,5.821-4.045c.095-1.36-3.313.985-8.355-1.234A6.914,6.914,0,0,1,5.816,0Z",
    transform: "translate(12.84 155.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Foot2",
    className: "cls-29",
    d: "M17.464,5.406S17.372,8.62,14.992,8.62,1.115,8.276,0,3.069C-.091-.16,7.058.008,7.058.008s0,2.893.527,3.451A7.568,7.568,0,0,0,11.5,5.406,29.8,29.8,0,0,0,17.464,5.406Z",
    transform: "translate(39.761 155.154)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-53",
    transform: "matrix(1, 0, 0, 1, -167.66, -59.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Feet-2",
    "data-name": "Feet",
    className: "cls-30",
    d: "M8.08,0S6.049,12.5,4.38,26.864,0,69.53,0,69.53a8.388,8.388,0,0,0,6.174,4.5,11.117,11.117,0,0,0,8.249-1.767s11.5-58.4,11.826-59.36,1.034.254-.18,4.168.745,34.9.745,34.9l1.373,20.74S30.469,74.7,34.981,74.7A12.924,12.924,0,0,0,42.2,72.709s.066-27.981-.384-42.155S39.9.33,39.9.33,34.161,4.71,23.168,4.387,8.08,0,8.08,0Z",
    transform: "translate(186.32 145.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Face",
    className: "cls-31",
    d: "M3.424,5.874C1.927,11.272,0,12.184,0,16.058s1.533,7.754,3.987,9.475A24.181,24.181,0,0,0,9.235,28.22v1.625a44.724,44.724,0,0,0,6.046.434,14.337,14.337,0,0,0,5.094-.623v-2.5s-4.765.82-6.346-1.622a8.842,8.842,0,0,1,1.58-10.32c3.049-2.771,3.95-8.03-.984-7.619C10.585,7.979,5.689,2.055,4.527.56S4.921.476,3.424,5.874Z",
    transform: "translate(33.212 12.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-32",
    d: "M1.125,12.091c-4.1-14.74,3.943-13.175,9-9.89,3.91,2.542,6.281.474,10.442,1.935,16.015,5.625,14.021,22.6,6.653,29.772-5.951,5.752-11.6,6.146-14.319,5.208s-4.544-6.557-1.379-10.4,5-6.408,2.546-8.35S9.739,23.322,1.125,12.091Z",
    transform: "translate(36.123)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52",
    transform: "matrix(1, 0, 0, 1, -167.66, -59.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right-hand-2",
    "data-name": "right-hand",
    className: "cls-33",
    d: "M4.4,0S10.1,12.746,9.373,25.592c-.7,10.122-1.192,13.224-5.112,13.224S0,30.075,0,30.075s3.375-7.267,4.262-12.648S4.4,0,4.4,0Z",
    transform: "translate(227.07 114.78)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pointing",
    className: "cls-31",
    d: "M4.084,20.831A23.383,23.383,0,0,0,.8,13.478C-1.952,9.091,4.777,7.1,4.777,7.1A23.831,23.831,0,0,0,3.414,1.6c-.871-1.763.543-2,1.027-1.032C6.227,3.814,8.685,8.107,8.685,8.107s4.569.2,2.081,4.113c-1.7,3.078-.67,6.932-.67,6.932a8.019,8.019,0,0,0-3.374-.269A6.413,6.413,0,0,0,4.084,20.831Z",
    transform: "translate(0.466 20.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-3",
    "data-name": "Path 6",
    className: "cls-34",
    d: "M5.174,0a59.366,59.366,0,0,1-.252,15.538A44.437,44.437,0,0,1,0,28.915H2.174s1.672-2.032,4.244-11.1A27.051,27.051,0,0,0,5.981,1.923C5.8,1.33,5.174,0,5.174,0Z",
    transform: "translate(59.035 56.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body",
    className: "cls-35",
    d: "M37.6,2.8c-.7.317-.1,1.807-.706,2.519s-1.214-.365-9.207,2.82-9.727,5.137-13.556,6.109c-2.6.371-2.422-16.9-11.263-13.894C-4.6,3.018,4.737,22.8,5.975,25.155s4.726,4.792,22.233-1.088c.138-.164.162.379.162.379L22.36,26.278s-1.7,8.13-1.7,12.011-.353,8.941,5.918,11.554S49.955,53.4,54.782,47.57c5.035-6.5,8.131-25.882,4.517-32.953S50.67,7.1,50.67,7.1s.523-3.9,0-4.555-.842.659-6.128.659S38.3,2.48,37.6,2.8Z",
    transform: "translate(3.898 38.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow",
    className: "cls-36",
    d: "M1.677,1.811,7.7,0s.5,4.514.439,6.7-.8,6.7-.8,6.7H0a40.979,40.979,0,0,1,.683-6.1C1.033,5.452,1.677,1.811,1.677,1.811Z",
    transform: "translate(24.577 63.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand",
    className: "cls-37",
    d: "M.142.4,0,6.107s.036,1.24.552,1.24,1.378-1.388,1.378,0-.138,5.235-.138,5.235a5.838,5.838,0,0,0,4.7-5.235A12.253,12.253,0,0,0,4.925,0,3.82,3.82,0,0,1,2.667,1.049,4.336,4.336,0,0,1,.142.4Z",
    transform: "translate(61.591 93.009)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(40 96)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51",
    transform: "matrix(1, 0, 0, 1, -38.66, -96.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-4",
    "data-name": "bg",
    className: "cls-1",
    width: 32.566,
    height: 21.452,
    rx: 3,
    transform: "translate(38.66 96.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Card-2",
    "data-name": "Card",
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_9",
    "data-name": "Rectangle Copy 9",
    className: "cls-39",
    width: 5.428,
    height: 2.979,
    transform: "translate(13.569 11.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_5",
    "data-name": "Rectangle Copy 5",
    className: "cls-40",
    width: 9.046,
    height: 2.979,
    transform: "translate(2.714 11.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    className: "cls-41",
    width: 39.2,
    height: 2.979,
    transform: "translate(-6.634 4.469)"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "circle_copy_5",
    "data-name": "circle copy 5",
    className: "cls-42",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(141)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle_copy_6",
    "data-name": "circle copy 6",
    className: "cls-24",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(29 59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_3-2",
    "data-name": "Rectangle Copy 3",
    className: "cls-43",
    width: 8.429,
    height: 8.429,
    transform: "translate(216.96 25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_12",
    "data-name": "Rectangle Copy 12",
    className: "cls-44",
    width: 5.619,
    height: 5.619,
    transform: "translate(285.551 136.631) rotate(45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Euro",
    transform: "matrix(-0.616, 0.788, -0.788, -0.616, 285.422, 69.582)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50",
    transform: "matrix(-0.62, -0.79, 0.79, -0.62, 119.67, 267.01)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    "data-name": "Oval",
    className: "cls-45",
    cx: 10.756,
    cy: 11.219,
    rx: 10.756,
    ry: 11.219,
    transform: "matrix(-0.62, 0.79, -0.79, -0.62, 282.78, 70.92)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    "data-name": "Oval",
    className: "cls-46",
    cx: 10.288,
    cy: 11.219,
    rx: 10.288,
    ry: 11.219,
    transform: "translate(0.9 0.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2-4",
    "data-name": "\\u20AC",
    className: "cls-15",
    d: "M0,6.706.462,5.586H.948q-.019-.3-.02-.576,0-.375.031-.7H0L.459,3.192h.723A4.3,4.3,0,0,1,5.731,0,8.071,8.071,0,0,1,7.944.3V1.711a5.137,5.137,0,0,0-2.091-.436A2.579,2.579,0,0,0,3.126,3.195l4.214,0L6.88,4.318l-4.029,0a3.82,3.82,0,0,0-.031.557q0,.4.026.718l3.511,0L5.9,6.712l-2.814,0A3.453,3.453,0,0,0,4.2,8.331,3.226,3.226,0,0,0,6.06,8.79a5.1,5.1,0,0,0,1.892-.412V9.7a6.7,6.7,0,0,1-2.327.36A4.237,4.237,0,0,1,1.134,6.707Z",
    transform: "matrix(-0.996, -0.087, 0.087, -0.996, 15.38, 16.975)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3-4",
    "data-name": "$",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 14.957, 144.231)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49",
    transform: "matrix(0.82, -0.57, 0.57, 0.82, -94.17, -110.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    "data-name": "Oval",
    className: "cls-47",
    cx: 11.691,
    cy: 11.706,
    rx: 11.691,
    ry: 11.706,
    transform: "matrix(0.82, 0.57, -0.57, 0.82, 13.6, 146.08)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    "data-name": "Oval",
    className: "cls-48",
    cx: 10.756,
    cy: 11.706,
    rx: 10.756,
    ry: 11.706,
    transform: "translate(0.353 0.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-15",
    d: "M4.242,12.174H3.2v-1.46a8.431,8.431,0,0,1-3.172-.625V8.167a9.252,9.252,0,0,0,1.557.554A8.669,8.669,0,0,0,3.209,9V6.748l-.519-.19A5.534,5.534,0,0,1,.614,5.323,2.326,2.326,0,0,1,0,3.674,2.135,2.135,0,0,1,.842,1.942a4.246,4.246,0,0,1,2.345-.825V0H4.226V1.086a8.433,8.433,0,0,1,3.068.671l-.7,1.7A8.049,8.049,0,0,0,4.226,2.89V5.037A11.254,11.254,0,0,1,6.3,5.985a2.829,2.829,0,0,1,.9.876,2.159,2.159,0,0,1,.28,1.122,2.313,2.313,0,0,1-.851,1.86,4.29,4.29,0,0,1-2.388.841v1.489Zm.021-5.036V8.951c.663-.117.986-.4.986-.86H5.27a.645.645,0,0,0-.249-.513A3.406,3.406,0,0,0,4.262,7.138ZM3.245,2.905c-.656.107-.976.359-.976.769h.021a.678.678,0,0,0,.223.512,2.714,2.714,0,0,0,.732.426Z",
    transform: "translate(7.751 6.184)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeEnd);
export default __webpack_public_path__ + "static/media/welcome-end.d7646ca55d0a537a2a2a5d25b1140130.svg";
export { ForwardRef as ReactComponent };